@use "variables" as *;

.mainContent {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition:
    margin-left 0.3s ease,
    width 0.3s ease;
}

.mainContentWide {
  height: 100vh;
  width: calc(100vw - 310px);
  margin-left: 310px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition:
    margin-left 0.18s ease-out,
    width 0.18s ease-out;
}
